import PropTypes from 'prop-types'
import React from 'react'

// Components
import Icon from 'app/views/components/Icon'
import TipsForGettingOutput from 'app/views/components/TipsForGettingOutput'


const propTypes = {
  output: PropTypes.string,
}
const defaultProps = {
  output: '',
}


const CodeOutput = ({ output }) => (
  <div>
    <h4>Code Output & Errors</h4>
    {(output) && (
      <div className="uk-margin-top">
        <textarea
          data-test-id="code-output-textarea"
          spellCheck="false"
          style={{
            width: 'calc(100% - 30px)',
            height: 350,
            resize: 'none',
            padding: 15,
            background: '#333',
            border: '1px solid #444',
            color: '#EEE',
            font: '11px/normal "Monaco", "Menlo", "Ubuntu Mono", "Consolas", "source-code-pro", monospace',
          }}
          data-uk-htmleditor
          value={output}
          disabled
        />
      </div>
    )}

    <TipsForGettingOutput />

  </div>
)

CodeOutput.propTypes = propTypes
CodeOutput.defaultProps = defaultProps

export default CodeOutput
